import React, { act, useState } from 'react';
import { FormComponent } from '../../component/form/FormComponent';
import { Field } from '../../types/FromComponent.types';
import { useAuth } from '../../context/authContext';
import { useLoading } from '../../context/loadingContext';
import { LoadingScreenGlobal } from '../other/LoadingScreen';
import { useNotification } from '../../context/notificationContext';
import { useNavigate } from 'react-router-dom';
import * as Invitation from '../../api/invitation';
import { isSuccessCode } from '../../helpers/apiResponse';

const UserAddScreen: React.FC = () => {

    const { association } = useAuth();
    const { setLoadingStatus, loading } = useLoading();
    const { addNotification } = useNotification();
    const nav = useNavigate();

    const fields: Field[] = [
        { name: 'email', placeholder: 'Enter the athlet email', type: 'email', autoIncrement: true },
        { name: 'role', placeholder: 'Select the role', type: 'dropdown', options: [{id: "athlete", value: "Athlete"}, { id: "coach", value: "Coach"}] }
    ];

    const handleSubmit = async (data: { [key: string]: string | string[] }) => {
        setLoadingStatus(true);
        if (data['email'] == "")
            return addNotification("Missing email", "You need to inser an email", "error");
        const response = await Invitation.add({ email: data['email'] + "", role: data['role'] + "" });
        console.log(response);
        if (isSuccessCode(response.error_code)) {
            setLoadingStatus(false);
            addNotification("Invitation sent", "Invitation to " + data['email'] + " has been sent", "success");
            nav("/user/invitations");
        } else if (response.error_code === "04.04.63") {
            setLoadingStatus(false);
            addNotification("User already invited", "The user with email " + data['email'] + " has already been invited", "error");
        } else {
            nav("/500?process_id=" + response.request_id + "&error_code=" + response.error_code);
        }
        

    };

    if (loading)
        return (<LoadingScreenGlobal />);

    return (
        <div className="view-screen-users">
            <FormComponent title="Invite user" fields={fields} onSubmit={handleSubmit} />
        </div>
    );
};

export default UserAddScreen;
